import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../../styles/auth/VerifyEmail.css';

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(true);
    const [verified, setVerified] = useState(false);

    useEffect(() => {
        const verifyToken = async () => {
            const token = searchParams.get('token');
            
            if (!token) {
                setError('Ingen verifiserings-token funnet i URL-en');
                setLoading(false);
                return;
            }

            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-email`,
                    { token }
                );

                if (response.data.success) {
                    setSuccess('E-postadressen din har blitt verifisert!');
                    setVerified(true);
                    // Redirect to login after 3 seconds
                    setTimeout(() => {
                        navigate('/login');
                    }, 3000);
                } else {
                    setError(response.data.message || 'Kunne ikke verifisere e-postadressen');
                }
            } catch (err) {
                setError(err.response?.data?.message || 'Feil ved verifisering av e-postadresse');
            } finally {
                setLoading(false);
            }
        };

        verifyToken();
    }, [searchParams, navigate]);

    return (
        <div className="verify-email-container">
            <div className="verify-email-card">
                <h1>Verifiser e-postadresse</h1>
                {loading && (
                    <div className="loading-message">
                        <div className="spinner"></div>
                        <p>Verifiserer e-postadresse...</p>
                    </div>
                )}
                {error && !loading && (
                    <div className="error-message">
                        {error}
                    </div>
                )}
                {success && !loading && (
                    <div className="success-message">
                        {success}
                        <p className="redirect-message">Du blir omdirigert til innlogging om et øyeblikk...</p>
                    </div>
                )}
                {!loading && !error && !success && (
                    <div className="info-message">
                        <p>Venter på verifisering...</p>
                    </div>
                )}
                {!loading && error && (
                    <>
                        <p className="resend-hint">
                            Lenken kan ha utløpt (den er gyldig i 24 timer).{' '}
                            <Link to="/resend-verification" className="resend-hint-link">Send ny verifiseringslenke</Link>
                        </p>
                        <div className="actions">
                            <button 
                                onClick={() => navigate('/login')}
                                className="btn-primary"
                            >
                                Gå til innlogging
                            </button>
                            <button 
                                onClick={() => navigate('/create-account')}
                                className="btn-secondary"
                            >
                                Opprett ny konto
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;
